import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';

/**
 * A custom element that allows the user to clean a search input.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} searchPageInput - The search input element.
 * @extends {Component<Refs>}
 */
/** La búsqueda no enseña agotados marcados para ocultarse. El cuadro muestra solo lo escrito. */
const HIDDEN_FROM_SEARCH = ' NOT tag:"web:oculto"';

class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.searchPageInput.form?.addEventListener('submit', () => {
      const input = this.refs.searchPageInput;
      const value = input.value.trim();
      if (value && !value.includes('NOT tag:"web:oculto"') && !value.includes('id:')) {
        input.value = `${value}${HIDDEN_FROM_SEARCH}`;
      }
    });
  }

  /**
   * Handles the keydown event on the search input and resets the search when
   * empty and Escape is pressed.
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();

    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
    }
  }, 100);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;

    searchInput.focus();
    searchInput.value = '';

    if (this.#isEmptyState()) return;

    searchInput.form?.submit();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get('q') ?? '';

    return queryParam.trim() === '';
  };
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}
